"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedusercircle = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedusercircle` : '') + (description ? ` desc-brandedusercircle` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedusercircle"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedusercircle"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58 28.9862C58 44.9918 45.0162 57.9745 29.0026 57.9745C12.9891 57.9745 0 44.9971 0 28.9862C0 12.9754 12.9838 0.00323486 28.9974 0.00323486C45.0109 0.00323486 57.9948 12.9806 57.9948 28.9862H58Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7253 0.00309612V58.0005C21.5074 57.7281 13.5606 54.7785 8.14061 49.1726C-2.98239 37.657 -2.6574 19.3094 8.85873 8.18672C14.5932 2.65417 21.3396 -0.0964478 28.7253 0.00309612Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.0011 19.9905C41.0011 26.6128 35.6283 31.983 29.0028 31.983C22.3772 31.983 17.0044 26.6128 17.0044 19.9905C17.0044 13.3682 22.3772 7.99811 29.0028 7.99811C35.6283 7.99811 41.0011 13.3682 41.0011 19.9905Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99756 48.0408C10.8031 39.7473 19.2213 33.9842 28.9972 33.9842C38.7731 33.9842 47.1966 39.7473 50.9968 48.0408C45.645 54.1287 37.7719 57.969 28.9972 57.969C20.2225 57.969 12.3494 54.1235 6.99756 48.0408Z",
    fill: "#FFF5EB"
  }));
};
var _default = exports.default = brandedusercircle;